/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".description-link{font-size:small}.exit-btn,.exit-btn:hover{color:#fff}hr{margin:10px 0!important}hr.compact{display:none}"];
export { styles as styles };
